import { ComponentProps, useCallback } from 'react';
import { Linking, Platform, StyleSheet, TouchableOpacity } from 'react-native';
import { useNavigation } from '@react-navigation/native';

import { ArrowRightIcon, Text } from '@pletly/ui';

export const WebLink = ({
	title = '',
	url: uri,
	children,
	withArrow,
	...textProps
}: WebLinkProps) => {
	const { navigate } = useNavigation();

	const openLink = useCallback(() => {
		if (Platform.OS === 'web') {
			return Linking.openURL(uri);
		}

		return navigate('WebContent', {
			title,
			uri,
		});
	}, [navigate, title, uri]);

	const textLink = (
		<Text status="primary" category="h5" onPress={openLink} {...textProps}>
			{children}
		</Text>
	);

	if (withArrow) {
		return (
			<TouchableOpacity onPress={openLink} style={styles.root}>
				{textLink}
				<ArrowRightIcon />
			</TouchableOpacity>
		);
	}

	return textLink;
};

const styles = StyleSheet.create({
	root: {
		flex: 1,
		flexDirection: 'row',
		justifyContent: 'space-between',
	},
});

export type WebLinkProps = Omit<ComponentProps<typeof Text>, 'onPress'> & {
	title: string;
	url: string;
	withArrow?: boolean;
};
